<template>
  <div
      class="vendasNoMes"
      v-loading="isLoading"
      style="padding: 10px; background: #fff; border-radius: 8px;"
  >
    <h3 style="text-align: center; margin-bottom: 1rem">Vendas no Mês</h3>
    <div class="mb-20" style="display: flex; justify-content: center">
      <apexchart
          height="350"
          width="400"
          type="pie"
          :options="chartOptions"
          :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import { makeErrorFilds } from "@/app/plugins/utils";
import { getSellType } from "@/app/domains/Core/services";

  export default {
    name: 'VendasNoMes',

    data() {
      return {
        isLoading: false,
        boxAtualStyle: {
          background: "var(--primary-color)",
          color: "var(--secondary-color)",
        },

        chartOptions: {
          style: {
            fontSize: "15px",
            colors: ["#304758"],
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                return (
                    "R$ " +
                    Intl.NumberFormat("pt-BR", {
                      style: "decimal",
                      currency: "BRL",
                      minimumFractionDigits: 0,
                    }).format(val)

                );
              },
            },
          },
          chart: {
            id: "vuechart-example",
            type: "pie",
          },
          labels: ["Crédito a vista", "Crédito parcelado", "Débito", "Pix"],
          legend: {
            show: true,
            position: "bottom",
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return (
                  "" +
                  Intl.NumberFormat({
                    style: "percent",
                    minimumFractionDigits: 0,
                  }).format(val) +
                  "%"
              );
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
            },
          },
        },
        series: [],
      }
    },

    methods: {
      async init() {
        this.loadingPage = true;
        try {
          let response = await getSellType();
          this.series = [
            response.data.chart.creditOnSight,
            response.data.chart.creditParceled,
            response.data.chart.debit,
            response.data.chart.pix,
          ];
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: "error",
          });
        } finally {
          this.loadingPage = false;
        }
      }
    },

    async beforeMount() {
      await this.init();
    }
  }
</script>

<style scoped>

</style>